
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.391 16.862l1.313-1.313-1.97-8.533 3.611-3.61a1.39 1.39 0 000-1.97 1.39 1.39 0 00-1.97 0l-3.61 3.61-8.532-1.969L.92 4.39 7.812 8l-3.61 3.61-2.298-.328-.984.985 2.954 1.64 1.64 2.955.985-.985-.328-2.297 3.61-3.61 3.61 6.892z","fill":"#000"}})])
          )
        }
      }
    